/**
 * @file m站 服务规则
 */

import React, {Component} from 'react';
import {NavBar, List, Icon} from 'antd-mobile';
import NavBarComponent from '../../../component/common/NavBarComponent'
import './serviceRule.scss';

const Item = List.Item;

class HelpCenter extends Component {
    constructor() {
        super();
        this.state = {
            lists: [
                {
                  text: "租车时限",
                  url: "/commonProblem",
                  thumb: "/image/icon/calendar.png",
                  ispage: true,
                  datas: "https://h5.izuche.com/help/Rentaltime.html",
                },
                {
                  text: "数量限制",
                  url: "/commonProblem",
                  thumb: "/image/icon/calendar.png",
                  ispage: true,
                  datas: "https://h5.izuche.com/help/Quantitative.html",
                },
                {
                  text: "租车资格",
                  url: "/commonProblem",
                  thumb: "/image/icon/calendar.png",
                  ispage: true,
                  datas: "https://h5.izuche.com/help/RentalQualification.html",
                },
                {
                  text: "预定用车",
                  url: "/commonProblem",
                  thumb: "/image/icon/calendar.png",
                  ispage: true,
                  datas: "https://h5.izuche.com/help/ReservationVehicle.html",
                },
                {
                  text: "费用说明",
                  url: "/commonProblem",
                  thumb: "/image/icon/calendar.png",
                  ispage: true,
                  datas: "https://h5.izuche.com/help/Expensestatement.html",
                },
                {
                  text: "违章处理",
                  url: "/commonProblem",
                  thumb: "/image/icon/calendar.png",
                  ispage: true,
                  datas: "https://h5.izuche.com/help/disposepage.html",
                },
                {
                  text: "发票管理",
                  url: "/commonProblem",
                  thumb: "/image/icon/calendar.png",
                  ispage: true,
                  datas: "https://h5.izuche.com/help/invoices.html",
                },
            ]
        };
    }

    goPage(item) {
        const { ispage, url, datas, text } = item
        const {history} = this.props
        if (!!ispage) {
            this.props.history.push({
                pathname: '/webview',
                query: { url:datas, title:text }
            })
        } else {
            history.push({
                pathname: url
            })
        }
    }

    render() {
        return (
            <div id="serviceRule" className="page">
                <NavBarComponent>
                    <NavBar icon={<Icon type="left" color='#333' />} 
                    onLeftClick={() => {this.props.history.goBack()}} mode='light'>服务规则</NavBar>
                </NavBarComponent>
                <List>
                    {this.state.lists.map((item, index) => {
                        return <Item arrow="horizontal" className="bb" key={index}>
                                    <div className="fs24 list-item" style={{display: 'flex', alignItems: 'center', align: 'middle'}} onClick={() => {this.goPage(item)}}>
                                        {/* <img mode="scaleToFill" src={item.thumb}/> */}
                                        <div>{item.text}</div>
                                    </div>
                                </Item>
                    })}
                </List>
            </div>
        );
    }
}

export default HelpCenter;
